// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "ForSalePropertyV5",
    "RentalPropertyV5"
  ]);
}

function unwrap_fragment_ForSalePropertyV5_agentV2Id(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "AnonymousForSalePropertyAgent",
    "VisibleForSalePropertyAgent"
  ]);
}

let fragmentConverter = {"__root":{"ForSalePropertyV5_agentV2Id":{"u":"fragment_ForSalePropertyV5_agentV2Id"},"":{"u":"fragment"}}};

let fragmentConverterMap = {
  fragment_ForSalePropertyV5_agentV2Id: unwrap_fragment_ForSalePropertyV5_agentV2Id,
  fragment: unwrap_fragment
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

let Utils = {};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UseShouldShowPropertyDetails_propertyV5",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "agentV2Id",
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "agentV2",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Agent",
                  "kind": "LinkedField",
                  "name": "agent",
                  "plural": false,
                  "selections": (v1/*: any*/),
                  "storageKey": null
                }
              ],
              "type": "VisibleForSalePropertyAgent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/)
              ],
              "type": "AnonymousForSalePropertyAgent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "ForSalePropertyV5",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "agentId",
          "args": null,
          "concreteType": "Agent",
          "kind": "LinkedField",
          "name": "agent",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "type": "RentalPropertyV5",
      "abstractKey": null
    }
  ],
  "type": "PropertyV5",
  "abstractKey": "__isPropertyV5"
};
})());

let wrap_fragment = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_ForSalePropertyV5_agentV2Id = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment = unwrap_fragment;
exports.wrap_fragment = wrap_fragment;
exports.unwrap_fragment_ForSalePropertyV5_agentV2Id = unwrap_fragment_ForSalePropertyV5_agentV2Id;
exports.wrap_fragment_ForSalePropertyV5_agentV2Id = wrap_fragment_ForSalePropertyV5_agentV2Id;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
